module.exports = __webpack_public_path__ + "static/media/AC04003W_01.067d6516.png";